<template>
    <v-dialog
        v-model="isShown"
        :fullscreen="fullscreen"
        :hide-overlay="fullscreen"
        max-width="600px"
        :origin="origin"
        :persistent="persistent"
        :scrollable="scrollable"
        :transition="transition"
    >
        <v-card>

            <template v-if="type === 'alert'">
                <v-card-title class="title">{{ title }}</v-card-title>

                <v-card-text>
                    <slot/>
                </v-card-text>

                <v-card-actions v-if="actionItems && actionItems.length">
                    <v-spacer/>

                    <v-btn
                        v-for="item in actionItems"
                        color="primary"
                        :key="`alertDialogActionItem_${item.text}`"
                        text
                        @click="item.click ? item.click() : null"
                    >
                        {{ item.text }}
                    </v-btn>
                </v-card-actions>
            </template>

            <template v-if="type === 'simple'">
                <slot/>
            </template>

            <template v-if="type === 'confirmation'">
                <slot/>
            </template>

            <template v-if="type === 'full-screen'">
                <slot/>
            </template>

        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'Dialog',

        props: {
            actionItems: { type: Array },
            scrollable: { type: Boolean },
            show: { type: Boolean },
            title: { type: String },
            type: {
                type: String,
                default: 'alert', // alert, simple, confirmation, full-screen
            },
        },

        computed: {
            isShown: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$emit('update:show', value)
                },
            },

            isMobile() {
                return this.$vuetify.breakpoint.smAndDown
            },

            fullscreen() {
                if (this.type === 'full-screen') {
                    return this.isMobile
                }

                return false
            },

            navigationIcon() {
                return {
                    icon: 'close',
                    click: () => this.closeDialog(),
                }
            },

            origin() {
                if (this.type === 'full-screen' && !this.isMobile) {
                    return 'center center'
                } else {
                    return ''
                }
            },

            persistent() {
                const isAlert = this.type === 'alert'

                return isAlert
            },

            transition() {
                if (this.type === 'full-screen' && this.isMobile) {
                    return 'dialog-bottom-transition'
                } else {
                    return 'scale-transition'
                }
            },
        },

        methods: {
            closeDialog() {
                this.isShown = false
            },
        },
    }
</script>
